import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { CalendarDays } from "lucide-react";
import "../css/fixedheader.css";

function FixedHeader({ src, video }) {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 900);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 900);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const style = {
    backgroundImage: `url(${src})`,
  };

  return (
    <header className="wrapper-fixedheader" style={style}>
      <video className="header-video" autoPlay muted loop >
        <source src={video} type="video/mp4" />
      </video>

      <div className="title-fixedheader">
        <motion.p
          className="tag1"
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
           <CalendarDays  className="w-7 h-7" />
          <span>
            14, 15 y 16 de <b>octubre de 2026</b>
          </span>
        </motion.p>

        <motion.p
          className="tag2"
          initial={{ x: -150, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          XIV Congreso
        </motion.p>
        <motion.p
          className="tag3"
          initial={{ x: -150, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          Latinoamericano
        </motion.p>

        <motion.p className="tag4">de plantas</motion.p>

        <motion.p className="tag5">medicinales</motion.p>
      </div>
    </header>
  );
}

export default FixedHeader;
